import React, { Component } from 'react';
import { Divider, HTMLTable, Button, Intent, Tag } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';
import ContactForm from '../Components/ContactForm';

export default class WebFAQ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      faqs: [
        { q: 'How to fix C9 / C10 Connection Disconnect Error?', cat: 'TROUBLESHOOTING', views: 1420 },
        { q: 'What is the PC / IP Limit on this server?', cat: 'RULES', views: 980 },
        { q: 'How does the Silkroad Gateway Exploit Guard work?', cat: 'SECURITY', views: 650 },
        { q: 'How to claim Hourly Free Silk Online Rewards?', cat: 'GUIDE', views: 2100 },
      ]
    };
  }

  render() {
    return (
      <SideMenuWrapper>
        <h3 className="display-4 font-italic mb-3" style={{ fontSize: '1.5rem', color: '#182026' }}>
          Frequently Asked Questions & Support Desk
        </h3>
        <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
          Player troubleshooting guides, connection error resolutions, and direct support contact at <strong style={{ color: '#106ba3' }}>info@srofilter.com</strong>.
        </p>

        <Divider className="mb-4" />

        <HTMLTable bordered condensed striped style={{ width: '100%', fontSize: '0.82rem' }} className="mb-4">
          <thead>
            <tr>
              <th style={{ color: '#182026' }}>Question Title</th>
              <th style={{ color: '#182026' }}>Category</th>
              <th style={{ color: '#182026' }}>Player Views</th>
              <th style={{ color: '#182026' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {this.state.faqs.map((f, i) => (
              <tr key={i}>
                <td className="font-weight-bold" style={{ color: '#182026' }}>{f.q}</td>
                <td><Tag intent={Intent.PRIMARY} round>{f.cat}</Tag></td>
                <td className="font-mono text-warning">{f.views} Views</td>
                <td><Button icon="edit" small minimal intent={Intent.PRIMARY} text="Edit Answer" /></td>
              </tr>
            ))}
          </tbody>
        </HTMLTable>

        <Divider className="my-4" />

        <ContactForm />
      </SideMenuWrapper>
    );
  }
}
